<template lang="pug">
  .center
    section.custom-width(data-aos="fade-up", data-aos-delay="500")
      .box
        el-row(:gutter="16")
          el-col(:xs="12", :sm="6", :md="6")
            .center
              .item 
                img(:src="require('@/assets/svg/facebook.svg')")
          el-col(:xs="12", :sm="6", :md="6")
            .center
              .item 
                img(:src="require('@/assets/svg/instagram.svg')")
          el-col(:xs="12", :sm="6", :md="6")
            .center
              .item 
                img(:src="require('@/assets/svg/google.svg')")
          el-col(:xs="12", :sm="6", :md="6")
            .center
              .item 
                img(:src="require('@/assets/svg/youtube.svg')")
</template>

<script>
  export default {
    components: {},
    name: 'platforms',
  }
</script>

<style lang="sass" scoped>
  .box
    background: #F1F1F9
    padding: 32px
    margin: 64px 8px
    border-radius: 16px
    .item
      height: 45px
      @media (max-width: 767px)
        height: 30px
      img
        height: 40px
        transition: height .3s
        @media (max-width: 767px)
          height: 25px
      &:hover img
        height: 45px
        @media (max-width: 767px)
          height: 30px
</style>